import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/lib/query-keys'
import { cmsService } from '@/services/cms'
import type { FaqItem } from '@/services/cms'

const FAQ_PAGE_SIZE = 200

export function useFaq() {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: queryKeys.cms.faq({ limit: FAQ_PAGE_SIZE, offset: 0 }),
    queryFn: () => cmsService.getFaq({ limit: FAQ_PAGE_SIZE, offset: 0 }),
  })

  const items: FaqItem[] = data?.results ? [...data.results].sort((a, b) => a.order - b.order) : []

  return {
    items,
    count: data?.count ?? 0,
    isLoading,
    isError,
    error,
  }
}
